export default __webpack_public_path__ + "static/media/Image.3178dfa8.png";